const Footer = () => {
  return (
    <div className='bg-gray-900/90 text-left'>
      <div className='mx-auto container'>
        <p className='ml-5 text-md font-medium w-full my-5 mx-auto text-white'>© 2020 DM GROUP. All Rights Reserved.</p>
      </div>
    </div>
  )
}

export default Footer
